module.exports = __webpack_public_path__ + "../resources/img/ic_re_arcstream_qcells_logo.97ee3288.svg";